export default __webpack_public_path__ + "static/media/contact.f68b5562.jpg";